import { useCallback } from 'react';
import { useReactFlow } from '@xyflow/react';
import { useDispatch, useSelector } from 'react-redux';
import { updateNode, addNode, addEdge } from '../../../store/workflow/workflowSlice';
import i18n from '../../../i18n';

// Redux RootState 타입 정의
interface RootState {
  workflow: {
    nodes: any[];
    edges: any[];
  };
}

export function usePlaceholderClick(nodeId: string) {
  const dispatch = useDispatch();
  const nodes = useSelector((state: RootState) => state.workflow.nodes);
  const edges = useSelector((state: RootState) => state.workflow.edges);
  
  return useCallback(() => {
    // placeholder 노드 정보 가져오기
    const placeholderNode = nodes.find(n => n.id === nodeId);
    if (!placeholderNode) return;
    
    console.log('플레이스홀더 클릭됨:', nodeId);
    
    // placeholder를 실제 노드로 변경
    dispatch(updateNode({
      ...placeholderNode,
      type: 'csvData', // 또는 원하는 기본 노드 타입
      data: {
        ...placeholderNode.data,
        label: i18n.t('workflow:node.newData'),
        config: {
          filepath: '',
          delimiter: ',',
          hasHeader: true,
          encoding: 'UTF-8',
          mode: 'READ'
        }
      }
    }));
    
    console.log('노드 타입 변경됨:', nodeId, '-> csvData');
    
    // 새로운 placeholder 노드 추가 (기존 placeholder의 오른쪽에)
    const newPlaceholderId = `placeholder-${nodeId}-${Date.now()}`;
    
    const newPlaceholderNode = {
      id: newPlaceholderId,
      type: 'placeholder',
      position: {
        x: placeholderNode.position.x + 200, // 원래 노드보다 오른쪽에 배치
        y: placeholderNode.position.y
      },
      data: { label: i18n.t('workflow:node.placeholder') }
    };
    
    // 새 placeholder 노드 추가
    dispatch(addNode(newPlaceholderNode));
    
    // 새 노드와 placeholder 연결하는 edge 추가
    const newEdgeId = `${nodeId}-${newPlaceholderId}`;
    const newEdge = {
      id: newEdgeId,
      source: nodeId,
      target: newPlaceholderId,
      type: 'workflow'
    };
    
    dispatch(addEdge(newEdge));
    
    console.log('새 플레이스홀더 노드 및 엣지 추가:', newPlaceholderId, newEdgeId);
  }, [nodeId, nodes, edges, dispatch]);
} 